export default {
  sysid: 89// 系统ID
}



// WEBPACK FOOTER //
// ./src/utils/config.js